import React, { useState } from 'react';
import { Plus, Minus } from 'lucide-react';
import { faqs } from '../mock';

export default function FAQ() {
  const [open, setOpen] = useState(0);
  return (
    <section className="py-16 lg:py-24">
      <div className="max-w-4xl mx-auto px-5 lg:px-8">
        <div className="text-center mb-12">
          <span className="text-[#4FB3B8] uppercase tracking-[0.25em] font-black text-xs">Questions? We got answers</span>
          <h2 className="mt-3 text-3xl lg:text-5xl font-black text-[#2C3E50] leading-[1.05]">
            Frequently <span className="text-[#E64B2B]">asked</span>.
          </h2>
        </div>
        <div className="space-y-4">
          {faqs.map((f, i) => {
            const active = open === i;
            return (
              <div key={f.q} className={`bg-white rounded-2xl border-2 border-[#2C3E50] ${active ? 'paper-shadow-yellow' : ''}`}>
                <button onClick={() => setOpen(active ? -1 : i)} className="w-full flex items-center justify-between gap-4 text-left p-5">
                  <span className="font-black text-[#2C3E50] text-lg">{f.q}</span>
                  <span className={`w-9 h-9 rounded-full flex items-center justify-center border-2 border-[#2C3E50] shrink-0 ${active ? 'bg-[#E64B2B] text-white' : 'bg-[#F4B93E] text-[#2C3E50]'}`}>
                    {active ? <Minus size={16} strokeWidth={3} /> : <Plus size={16} strokeWidth={3} />}
                  </span>
                </button>
                {active && (
                  <div className="px-5 pb-5 -mt-1 text-[#2C3E50]/80 font-medium leading-relaxed">{f.a}</div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
